
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/people/open-positions",
      function () {
        return require("private-next-pages/people/open-positions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/people/open-positions"])
      });
    }
  